import { z } from 'zod';
import type { LanguageToken } from '@sleed/bizcommerce-api';

/**
 * Language edit form. Field names mirror the `LanguageToken` DTO (abbreviated server keys)
 * and the validation mirrors the legacy admin grid's RequiredRule/StringLengthRule
 * (Core/client/admin/src/pages/System/Languages/index.js): nm/ln ≤100, iso2 ≤2, cc ≤6, si required.
 */
export const languageSchema = z.object({
	id: z.number().optional(),
	nm: z.string().trim().min(1, 'validation.required').max(100, 'validation.tooLong'),
	ln: z.string().trim().min(1, 'validation.required').max(100, 'validation.tooLong'),
	iso2: z.string().trim().min(1, 'validation.required').max(2, 'validation.tooLong'),
	cc: z.string().trim().min(1, 'validation.required').max(6, 'validation.tooLong'),
	iv: z.boolean(),
	si: z.number({ message: 'validation.required' }).int()
});

export type LanguageFormValues = z.infer<typeof languageSchema>;

export const EMPTY_LANGUAGE: LanguageFormValues = { nm: '', ln: '', iso2: '', cc: '', iv: true, si: 0 };

export function tokenToForm(token: LanguageToken): LanguageFormValues {
	return {
		id: token.id,
		nm: token.nm ?? '',
		ln: token.ln ?? '',
		iso2: token.iso2 ?? '',
		cc: token.cc ?? '',
		iv: token.iv ?? false,
		si: token.si ?? 0
	};
}

export function formToToken(form: LanguageFormValues): LanguageToken {
	return { id: form.id, nm: form.nm.trim(), ln: form.ln.trim(), iso2: form.iso2.trim(), cc: form.cc.trim(), iv: form.iv, si: form.si };
}
